import React from "react";
import { Reveal } from "./Reveal";
const BONO1 = "https://cdn.magicpatterns.com/uploads/1QULPYRzBfit6Gg8mNEvEF/BONO_1_SALES.png";
const BONO2 = "https://cdn.magicpatterns.com/uploads/npFzPLfKPd1PmniCfbDZub/BONO_2_SALES.png";
const BONO3 = "https://cdn.magicpatterns.com/uploads/ewQrcvrY5ViNWYJFVLSGWv/BONO_3_SALES.png";
const BONO4 = "https://cdn.magicpatterns.com/uploads/dS6xQToDokN1cLkbz4zJNW/BONO_4_SALES.png";
const BONO5 = "https://cdn.magicpatterns.com/uploads/bqDnrj2d5b61h8fABXqKsu/BONO_5_SALES.png";
const bonuses = [{
  num: "#1",
  image: BONO1,
  title: "Recetario Premium de Sales de Baño™",
  text: "30 recetas listas para preparar las variedades más populares.",
  tags: ["Relajantes", "Florales", "Detox", "Energizantes"]
}, {
  num: "#2",
  image: BONO2,
  title: "Directorio de Proveedores™",
  text: "Encuentra fácilmente dónde comprar ingredientes, envases y materiales.",
  tags: ["Ingredientes", "Envases", "Etiquetas", "Packaging"]
}, {
  num: "#3",
  image: BONO3,
  title: "Calculadora de Costos y Precios™",
  text: "Calcula el costo real de cada producto y descubre cuánto cobrar.",
  tags: ["Costos", "Ganancias", "Precio sugerido"]
}, {
  num: "#4",
  image: BONO4,
  title: "Pack de Etiquetas Editables™",
  text: "Plantillas listas para personalizar y dar una imagen profesional a tu marca.",
  tags: ["Etiquetas", "Stickers", "Tarjetas"]
}, {
  num: "#5",
  image: BONO5,
  title: "Guía Primeras Ventas™",
  text: "Aprende cómo presentar tu nueva línea y conseguir tus primeros clientes.",
  tags: ["Ideas de publicación", "Textos listos", "Lanzamiento"]
}];
export function Bonuses() {
  return <section className="w-full bg-[#fbf5f0] px-5 py-14" data-id="element-15" data-mp="33ge5iy38ltlp">
      <div className="mx-auto max-w-xl" data-id="element-16" data-mp="nprllcosuxn9">
        <Reveal className="text-center" data-id="element-17" data-mp="noqax9bp4d62">
          <span className="inline-block rounded-full bg-[#a04a63] px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-white" data-id="element-18" data-mp="iqyhgavekizr">
            🎁 5 Bonos exclusivos
          </span>
          <h2 className="mt-4 font-serif-display text-2xl font-semibold text-[#3d2b30] sm:text-3xl" data-id="element-19" data-mp="3cl0sczvj44fq">
            Incluidos GRATIS por tiempo limitado
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm text-[#6b565b] sm:text-base" data-id="element-20" data-mp="3lkwajoni4zp9">
            Porque no queremos que solo aprendas a hacer sales de baño… queremos que tengas
            todo lo necesario para lanzar tu primera línea.
          </p>
        </Reveal>

        <div className="mt-8 space-y-4" data-id="element-21" data-mp="2xtih1fdm6y2p">
          {bonuses.map((b, i) => <Reveal key={b.num} delay={i * 0.04} data-id="element-22" data-mp="32t3gdqwp58fy" data-mpi={i}>
              <div className="relative overflow-hidden rounded-2xl border border-[#e7d3d8] bg-white p-5" data-id="element-23" data-mp="32sbkeez6t8p5">
                <div className="mb-3 flex items-center justify-between" data-id="element-24" data-mp="37lefwsniys7z">
                  <span className="rounded-full bg-[#f0e0e4] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-[#a04a63]" data-id="element-25" data-mp="2a57kgoeybkk8">
                    Bono {b.num}
                  </span>
                  <span className="text-xs font-bold text-[#9a7d84] line-through" data-id="element-26" data-mp="27kjaisdvi1ik">
                    Valor: $17 USD
                  </span>
                </div>

                <div className="flex items-start gap-4" data-id="element-27" data-mp="22j3tdbetgf5g">
                  {b.image ? <img src={b.image} alt={b.title} className="h-24 w-24 flex-shrink-0 rounded-xl object-contain" data-id="element-28" data-mp="1xnwt6dkr9sla" /> : <span className="flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-xl bg-[#fbf5f0] text-4xl" data-id="element-29" data-mp="1jup0eikxur20">
                      {b.emoji}
                    </span>}
                  <div data-id="element-30" data-mp="19wrew2ugr8d3">
                    <h3 className="font-serif-display text-base font-semibold leading-snug text-[#3d2b30]" data-id="element-31" data-mp="19xapeyhsauh3">
                      {b.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-[#6b565b]" data-id="element-32" data-mp="10vta3ic7awtg">{b.text}</p>
                    <div className="mt-3 flex flex-wrap gap-1.5" data-id="element-33" data-mp="30xsvnmtqp08t">
                      {b.tags.map(tag => <span key={tag} className="rounded-full bg-[#fbf5f0] px-2.5 py-1 text-[0.65rem] font-semibold text-[#a04a63]" data-id="element-34" data-mp="34zxhw0huyulf">
                          ✔ {tag}
                        </span>)}
                    </div>
                  </div>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}